import {accountApi} from 'common/api/entitiesApi'
import React, { useEffect } from 'react';
import { Result, message } from 'antd';
import { WarningOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const ServerMaintenance: React.FC = () => {
    const navigate = useNavigate();

    useEffect(() => {
        const interval = setInterval(async () => {
            try {
                const user = await accountApi.accountProps();
                if (user) {
                    message.success('Server is back! Redirecting...');
                    clearInterval(interval);
                    navigate('/');
                }
            } catch (err) {
                // ignore errors, keep polling
            }
        }, 5000);

        return () => clearInterval(interval); // cleanup on unmount
    }, [navigate]);

    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
            width: '100vw',
            height: '100vh'
        }}>
            <Result
                icon={<WarningOutlined style={{ color: '#faad14', fontSize: 48 }} />}
                title="Server Maintenance"
                subTitle="The server is currently down for maintenance. Please try again later."
                style={{ paddingBottom: '10vh' }}
            />
        </div>
    );
};

export default ServerMaintenance;
